import { notification } from "antd";
import type { ReactNode } from "react";
import type { ArgsProps } from "antd/es/notification";
import styles from "./styles.module.scss";

type NotificationCallerData = Omit<ArgsProps, "message"> & { text: ReactNode };

type NotificationCaller = (data: NotificationCallerData) => void;

export const useNotification = () => {
  const callInfoNotification: NotificationCaller = ({ text, ...data }) => {
    notification.info({
      message: text,
      className: styles.info,
      ...data,
    });
  };

  const destroyAllNotification = () => {
    notification.destroy();
  };

  const destroyNotification = (key: string) => {
    notification.destroy(key);
  };

  return {
    callInfoNotification,
    destroyAllNotification,
    destroyNotification,
  };
};
